import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useSettings } from '@/context/SettingsContext';
import { Music, Sparkles, Sun, Heart } from 'lucide-react';

const EntertainmentPage = () => {
  const { t } = useLanguage();
  const { settings } = useSettings();

  const activities = [
    {
      icon: Music,
      title: t('entertainment.liveMusic.title'),
      description: t('entertainment.liveMusic.description'),
      image: 'https://images.pexels.com/photos/167636/pexels-photo-167636.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
    {
      icon: Sparkles,
      title: t('entertainment.themeShows.title'),
      description: t('entertainment.themeShows.description'),
      image: 'https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
    {
      icon: Sun,
      title: t('entertainment.dayActivities.title'),
      description: t('entertainment.dayActivities.description'),
      image: 'https://images.pexels.com/photos/12203460/pexels-photo-12203460.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
    {
      icon: Heart,
      title: t('entertainment.aerobics.title'),
      description: t('entertainment.aerobics.description'),
      image: 'https://images.pexels.com/photos/3822906/pexels-photo-3822906.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
  ];

  return (
    <div data-testid="entertainment-page">
      {/* Hero */}
      <section
        className="relative h-[60vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg?auto=compress&cs=tinysrgb&w=1920')`
        }}
      >
        <div className="absolute inset-0 bg-holiday-purple/60" />
        <div className="relative z-10 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4">{t('entertainment.title')}</h1>
          <p className="text-xl text-white/80">{t('entertainment.subtitle')}</p>
        </div>
      </section>

      {/* Activities Grid */}
      <section className="section-padding bg-white" data-testid="activities-section">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {activities.map((activity, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 lg:h-[300px]"
                data-testid={`activity-${index}`}
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 h-full">
                  <div className="aspect-[4/3] lg:aspect-auto lg:h-full overflow-hidden">
                    <img
                      src={activity.image}
                      alt={activity.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-8 flex flex-col justify-center h-full">
                    <div className="w-12 h-12 bg-holiday-purple/10 rounded-full flex items-center justify-center mb-4">
                      <activity.icon className="w-6 h-6 text-holiday-purple" />
                    </div>
                    <h3 className="text-2xl font-heading font-bold text-gray-900 mb-2">
                      {activity.title}
                    </h3>
                    <p className="text-gray-600">{activity.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-holiday-purple text-white text-center">
        <div className="container-custom">
          <h2 className="text-4xl font-heading font-bold mb-4">
            {t('entertainment.subtitle')}
          </h2>
          <p className="text-white/80 mb-8">{t('hero.concept')}</p>
          <a
            href={settings.reservation_url || "https://www.ihg.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-accent inline-block rounded-sm"
            data-testid="entertainment-cta"
          >
            {t('nav.bookNow')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default EntertainmentPage;
